import{ reactive, ref } from "vue";
import { mapState } from "vuex";
import FileReader from "@/components/fileReader.vue";
import axios from "axios";
import { sqlTables } from "./tables";
import gql from "graphql-tag";
import { customCellEditor } from './tables/customCellEditor';
import "ag-grid-autocomplete-editor/dist/main.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import { AutocompleteSelectCellEditor } from "ag-grid-autocomplete-editor";
import {
    AgGridVue
} from "ag-grid-vue";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import {
    Card,
    Button,
    Badge,
    InfoSection,
    FormGroupInput,
    Checkbox
}
    from '@/components';
import {
    Select,
    Option,
    DatePicker
}
    from 'element-ui'


export default {
  name: "bulkupload",
  bodyClass: "tables",
  components: {
    FileReader,
    AgGridVue,
    //datePicker
  },
  data() {
    console.log("data");
    return {
      filereader: 0,
      sheetChanged: false,
      series: [],
      mutations: {
        INSERT_AACPVIS: gql`
          mutation Insert_CashManagement_AacpVI(
            $CashManagement_AacpVI_insert_input: [CashManagement_AacpVI_insert_input!]!
          ) {
            insert_CashManagement_AacpVI(
              objects: $CashManagement_AacpVI_insert_input
            ) {
              affected_rows
              returning {
                Id
              }
            }
          }
        `,
        INSERT_AAFLIIIS: gql`
          mutation Insert_CashManagement_AaflIII(
            $CashManagement_AaflIII_insert_input: [CashManagement_AaflIII_insert_input!]!
          ) {
            insert_CashManagement_AaflIII(
              objects: $CashManagement_AaflIII_insert_input
            ) {
              affected_rows
              returning {
                Id
              }
            }
          }
        `,
        INSERT_IVORYIVS: gql`
          mutation Insert_CashManagement_IvoryIV(
            $CashManagement_IvoryIV_insert_input: [CashManagement_IvoryIV_insert_input!]!
          ) {
            insert_CashManagement_IvoryIV(
              objects: $CashManagement_IvoryIV_insert_input
            ) {
              affected_rows
              returning {
                Id
              }
            }
          }
        `,
         INSERT_CASHMANAGEMENT: gql`mutation Insert_CashManagement_Transactions($CashManagement_Transactions_insert_input: [CashManagement_Transactions_insert_input!]!) {
                    insert_CashManagement_Transactions(objects: $CashManagement_Transactions_insert_input) {     
                        affected_rows
                        returning{
                            Id
                        }   
                    }
                }`,
        INSERT_MDIVS: gql`
          mutation Insert_CashManagement_MdIV(
            $CashManagement_MdIV_insert_input: [CashManagement_MdIV_insert_input!]!
          ) {
            insert_CashManagement_MdIV(
              objects: $CashManagement_MdIV_insert_input
            ) {
              affected_rows
              returning {
                Id
              }
            }
          }
        `,
      },
      modules: [ClientSideRowModelModule],
      columnDefs: null,
      rowData: null
    };
  },
  computed: {
    ...mapState({
      username: "user",
      gqlmap: 'gqlmap',
    }),
        spinner: {
            get: function() {
                return this.$store.getters.get('spinner');
            },
            set: function(val) {
                this.$store.commit('change', {
                    spinner: val
                })
            },
   mapping: {
    get: function () {
      let w = this;
      return sqlTables["cashManagement"] && sqlTables["cashManagement"].mapping
        ? sqlTables["cashManagement"].mapping
        : {};
    },
    set: function (val) {
      let w = this;
      sqlTables["cashManagement"].mapping = val;
    },
  }      },
  },
  beforeMount() {
        this.frameworkComponents = {
            // agDateInput: datePicker
        };
        let w = this;
        this.gridOptions = {
            headerHeight: 60,
            tooltipShowDelay: 5,
            cellFlashDelay: 500000000,
            rowClassRules: {
                'modified': function (params) {
                    return params.data.system_modified === true || params.data['FundName'] === 'aAGGREGATES';
                },
                'aggregated': function (params) {
                    return params.data['FundName'] === 'AGGREGATES';
                },
            },
            enableBrowserTooltips: false,
            animateRows: false,
            defaultColDef: {
                flex: 1,
                minWidth: 150,
                suppressClickEdit: true,
                filter: true
            },
            pagination: true,
            paginationPageSize: 20,
            onFirstDataRendered: function (params) { },
            onModelUpdated: function (params) {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                })
            },
            onGridReady: function (params) {
                window.addEventListener('resize', function () {
                    setTimeout(function () {
                        params.api.sizeColumnsToFit();
                    })
                })
            },
        }
        this.columnDefs = [
          {headerName: 'Deal', field: 'Deal', minWidth: 360, cellStyle: { textAlign: 'left' }},
          {headerName: 'Wire Date', field: 'WireDate' , maxWidth: 100, cellStyle: { textAlign: 'left' }},
          {headerName: 'Fund Name', field: 'FundName', minWidth: 360, cellStyle: { textAlign: 'left' }},
          {headerName: 'Balanced Checking',  minWidth: 100, field: 'FRBBalancedCKG', cellStyle: { textAlign: 'right' }},
          {headerName: 'Co-Invest Checking', minWidth: 100, field: 'FRBCoInvestCKG', cellStyle: { textAlign: 'right' }},
          {headerName: 'Tranche II Checking', minWidth: 100, field: 'FRBTrancheIICKG', cellStyle: { textAlign: 'right' }},
        ];
        this.rowData = [];
  },
  mounted() {
    this.splitdata = {};
    this.spinner = false;
    this.existingCashmanagementData = [];
    this.series = [];
    this.seriesData = []
    this.filereader = Date.now();
    //var reportContainer = document.getElementById("container");
    /*
    this.getSplitData("222");
    this.getSplitData("174");
    this.getSplitData("218");

    this.getCashmanagementData();
    */
  },
  methods: {
    getSplitData(fundid) {
      let w = this;
      var data = JSON.stringify({
        FundID: fundid,
      });

      var config = {
        method: "post",
        url: "https://asiaaltfunctions.azurewebsites.net/api/querySplits?code=hgG_DtbepOvlh2l-Ep01sYMOMyZkSUsqnQDZHSDgVRgZAzFuX5Uz-A==",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          const uniqueData = w.getUniqueListBy(
            response.data,
            "iLevel Deal Name"
          );
          w.splitdata[fundid] = uniqueData;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCashmanagementData() {
      let queryCashManagement = gql`
      query MyQuery {
          CashManagement_cashManagement {
              FundId
              AutomatedComments
              BalancedCKG
              BalancedMMA
              CKGBalance
              CashBalance
              CoInvestCKG
              CoInvestCKGBalance
              CoInvestMMA
              Deal
              FRBBalancedCKG
              FRBCoInvestCKG
              FRBTranchII
              TranchIICKG
              RunningFRBTranchII
              RunningTranchIICKG
              RunningFRBCoCKG
              RunningFRBBalCKG
              FXRate
              FXRateDate
              Notes
              TiesToBank
              Total
              WireDate
              Id
            
          }
       }`;

       this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
        let data = await this.$apollo.query({
            query: queryCashManagement,
            fetchPolicy: 'network-only'
        })
        setTimeout(() => {
            if (data.data) {
                
                if (Object.keys(data.data).length > 0) {
                    let q = Object.keys(data.data)[0]
                    this.existingCashmanagementData = JSON.parse(JSON.stringify(data.data[q]));
                    console.log('response:::', this.existingCashmanagementData);
                }
            }
        }, 301)
    })

    },

    getUniqueListBy(arr, key) {
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },

    showSignUp: function () {
      console.log("Request Access Modal");
    },
    loadTextFromFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => this.$emit("load", e.target.result);
      reader.readAsText(file);
    },
    groupedData(list, key) {
      return list.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    loadBulkSheet: async function (evt) {
        let w = this;
            w.rowData  = []
            w.series = []
      try {
        let rows = [];
        let data = new Uint8Array(evt);
        if (data && data.length) {
        w.spinner = true;
          let workbook = await XLSX.read(data, {
            type: "array",
            cellDates: true
          });
          let date = XLSX.utils.sheet_to_json(workbook.Sheets['Input'], {
              header: 1,
                  range: "B3"                                                                                                         })
          date = date && date[0] && date[0][0] ? date[0][0] : false
          //let sheets = workbook.SheetNames.filter(x => x.includes('Split'))
          let sheets = workbook.SheetNames.filter(x => x.includes('DIU'))
          let json = []
					sheets.map(sheet => {
								data = XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
								data.map( obj => {
								obj.Date = date ? date : obj['GL Date']
								delete obj['#']
								Object.keys(obj).map( x => {
								if ( x.includes('EMPTY') ) delete obj[x]
								})
									if ( obj['Deal'] !== '' ) {
                  json.push(obj);
                  }
								})
						})
          if (json) {
            let map = {};
            let reversemap = {};
            let mappingData =
              sqlTables["cashManagement"] && sqlTables["cashManagement"].mapping
                ? sqlTables["cashManagement"].mapping
                : {};
            let fields = Object.keys(mappingData);
            let columns = fields.map((x) => mappingData[x].header);
            columns.map((x, i) => {
              map[x] = fields[i];
              reversemap[fields[i]] = x;
            });
           json = json.sort( (a,b) =>  a.Funds >  b.Funds ? 1 : a.Funds <  b.Funds ? -1 : 0 )
           let batched = {}
            json.map((x, i) => {
              if ( x['Amount (LE)'] && x['Amount (LE)'] > 0 && (x['Transaction Type'] == 'Cash Disbursed' || x['Transaction Type'] == 'Cash Received') && !batched[`${x["Deal"]}:${x["Legal Entity"]}`] ) {
              batched[`${x["Deal"]}:${x["Legal Entity"]}`] = true
              let reverse = x['Transaction Type'] == 'Cash Disbursed' ? -1 : 1
              console.log(x["GL Date"])
              var item = {
                Deal: x["Deal"], 
                WireDate: w.getDateData(x["GL Date"]), 
                FundName: x["Legal Entity"], 
                //FRBBalancedCKG: !x["Deal"].toLowerCase().includes('tranch') && !x["Co-investment"] && x["Split %"] ? w.handleNegetiveValue( x["Cash Received"] * x["Split %"]) : null,
                //FRBBalancedCKG: !x["Deal"].toLowerCase().includes('tranch') && !x["Co-investment"] && x["Split %"] ? w.handleNegetiveValue( x["Cash Received"] ? x["Cash Received"] : x["Cash Disbursed"]) : null,
                FRBBalancedCKG: !x["Deal"].toLowerCase().includes('tranch') && !x["Deal"].toLowerCase().includes('co-invest') ? w.handleNegetiveValue(reverse * x['Amount (LE)']) :  null,
                //FRBCoInvestCKG: x["Co-investment"] && x["Split %"] ? w.handleNegetiveValue( x["Cash Received"] * x["Split %"]) : null,
                FRBCoInvestCKG: x["Deal"].toLowerCase().includes('co-invest') ? w.handleNegetiveValue(reverse * x['Amount (LE)']) : null,
                //FRBCoInvestCKG: x["Co-investment"] && x["Split %"] ? w.handleNegetiveValue( x["Cash Received"] ? x["Cash Received"] : x["Cash Disbursed"]) : null,
                //FRBTrancheIICKG: x["Deal"].toLowerCase().includes('tranch') ? w.handleNegetiveValue( x["Cash Received"] * x["Split %"]) : null
                //FRBTrancheIICKG: x["Deal"].toLowerCase().includes('tranch') ? w.handleNegetiveValue( x["Cash Received"] ? x["Cash Received"] : x["Cash Disbursed"]) : null
                FRBTrancheIICKG: x["Deal"].toLowerCase().includes('tranch') ? w.handleNegetiveValue(reverse * x['Amount (LE)']) : null,
              }
              w.rowData.push(item);
              }
            });
            w.series = json;
            w.seriesData = json;
        w.filereader = Date.now();
        this.spinner = false;
            //w.rowData = uniqueFund;
          }
        }
      } catch (err) {
        this.filereader = Date.now();
        this.$modal.show("dialog", {
          title: "Error!",
          text: err,
          class: "failure",
        });
        this.spinner = false;
      }
    },
    async saveChanges2() {
      try {
        let w = this;
        if (w.series && w.series.length>0) {
          w.spinner = true;
          let uniqueFund = w.getUniqueListBy(w.seriesData, 'Fund Name');
        console.log(uniqueFund)
          uniqueFund.map((y, i) => {
            const jsondata = w.series.filter(
              (item) => y["FundId"] == item["FundId"]
            );
              let mappingData =
                sqlTables["ivoryIv"] && sqlTables["ivoryIv"].mapping
                  ? sqlTables["ivoryIv"].mapping
                  : {};
              let fields = Object.keys(mappingData);
              var columnName = fields.map((z) => mappingData[z].col);
              jsondata.map(async (x, i) => {
                const ivoryCashData = w.existingCashmanagementData.filter(
                  (item) => x["FundId"] == item["FundId"]
                );
  
                console.log("ivoryCashData", w.existingCashmanagementData);

                var prepareData = {};
                columnName.forEach((item) => {
                  prepareData[item] = "";
                });

                prepareData["Id"] = 1;
                prepareData["FundId"] = x["FundId"].toString();
                prepareData["Deal"] = x["Deal"];
                prepareData["WireDate"] = w.handledateFormatter(  w.$moment.utc(x["WireDate"]).format("L"));
                //prepareData["ReceivedDate"] = w.handledateFormatter(  w.$moment.utc(x["ReceivedDate"]).format("L"));
                prepareData["FRBBalancedCKG"] = w.handleNegetiveValue( x["FRBBalancedCKG"]);
                prepareData["BalancedCKG"] = '';
                prepareData["CoInvestCKG"] = '';
                var itemdata = w.splitdata[x["FundId"]].filter(function (
                  item
                ) {
                  return item["iLevel Deal Name"] == x["Deal"];
                });
                if(prepareData.Deal == "Transfer between Balance" || prepareData.Deal == "Co-Investment Checking"){
                  prepareData.FRBBalancedCKG = w.handleNegetiveValue(w.getCellFormattedValue(x["FRBCoInvestCKG"]));
                  prepareData.CoInvestCKG = '0';//w.handleNegetiveValue(-1 * w.getCellFormattedValue(x["FRBCoInvestCKG"]));
                  prepareData.BalancedCKG = '0';
                  prepareData["FRBCoInvestCKG"] = w.handleNegetiveValue( x["FRBCoInvestCKG"]);
                }
                if(itemdata && itemdata.length === 0){
                  prepareData.BalancedCKG = w.handleNegetiveValue(w.getCellFormattedValue(prepareData.FRBBalancedCKG));
                } else {
                  var total = itemdata
                    .map((item) => item["Deal Commitment"])
                    .reduce((a, c) => {
                      return a + c;
                    });
                  itemdata.forEach((element) => {
                    if (element["Co-Investment Deal"]) {
                      var p1 = (
                        (element["Deal Commitment"] / total) *
                        100
                      ).toFixed(2);
                      prepareData["CoInvestCKG"] = w.handleNegetiveValue(
                        parseFloat((x["FRBBalancedCKG"] * p1) / 100).toFixed(2)
                      );
                    } else {
                      var p2 = (
                        (element["Deal Commitment"] / total) *
                        100
                      ).toFixed(2);
                      prepareData["BalancedCKG"] = w.handleNegetiveValue(
                        parseFloat((x["FRBBalancedCKG"] * p2) / 100).toFixed(2)
                      );
                    }
                  });
                }

                  var calcFRBBalancedCKG = w.getCellFormattedValue(prepareData.FRBBalancedCKG);
                  var balanceMMA = w.getCellFormattedValue(prepareData.BalancedMMA);
                  var coInvestMMA = w.getCellFormattedValue(prepareData.CoInvestMMA);
                  var fRBCoInvestCKG = w.getCellFormattedValue(prepareData.FRBCoInvestCKG);
                  prepareData.Total = w.handleNegetiveValue(parseFloat(parseFloat(balanceMMA + coInvestMMA + calcFRBBalancedCKG + fRBCoInvestCKG).toFixed(2)));
    
                  var calcBalancedCKG = w.getCellFormattedValue(prepareData.BalancedCKG)
                  var getCKGBalance = ivoryCashData.length > 0 ? w.getCellFormattedValue(ivoryCashData[ivoryCashData.length - 1].CKGBalance) : 0;
                  prepareData.CKGBalance = w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + calcBalancedCKG).toFixed(2)));

                  var getRunningFRBBalCKG =ivoryCashData.length > 0 ? w.getCellFormattedValue(ivoryCashData[ivoryCashData.length - 1].RunningFRBBalCKG) : 0;
                  var getFRBBalancedCKG = ivoryCashData.length > 0 ? w.getCellFormattedValue(ivoryCashData[ivoryCashData.length - 1].FRBBalancedCKG) : 0;
                  prepareData.RunningFRBBalCKG = w.handleNegetiveValue(parseFloat(parseFloat(getRunningFRBBalCKG + getFRBBalancedCKG).toFixed(2)));
                                
                  var getRunningFRBCoCKG = ivoryCashData.length > 0 ? w.getCellFormattedValue(ivoryCashData[ivoryCashData.length - 1].RunningFRBCoCKG) : 0;
                  var getFRBCoInvestCKG = ivoryCashData.length > 0 ? w.getCellFormattedValue(ivoryCashData[ivoryCashData.length - 1].FRBCoInvestCKG) : 0;
                  prepareData.RunningFRBCoCKG = w.handleNegetiveValue(parseFloat(parseFloat(getRunningFRBCoCKG + getFRBCoInvestCKG).toFixed(2)));

                  var calcTotal = w.getCellFormattedValue(prepareData.Total)
                  var getCashBalance = ivoryCashData.length > 0 ? w.getCellFormattedValue(ivoryCashData[ivoryCashData.length - 1].CashBalance) : 0;
                  prepareData.CashBalance = w.handleNegetiveValue(parseFloat(calcTotal + getCashBalance).toFixed(2));

                  var calcCoInvestCKG = w.getCellFormattedValue(prepareData.CoInvestCKG)
                  var getCoInvestCKGBalance =  w.getCellFormattedValue(ivoryCashData[ivoryCashData.length - 1].CoInvestCKGBalance);
                  prepareData.CoInvestCKGBalance = w.handleNegetiveValue(parseFloat(parseFloat(getCoInvestCKGBalance + calcCoInvestCKG).toFixed(2)));

                  var cashBalance = w.getCellFormattedValue(prepareData.CashBalance);
                  var todayDate = w.$moment.utc(new Date());
                  var wireDate = w.$moment.utc(prepareData.WireDate)
                  var dateDiff = todayDate.diff(wireDate, 'days');
                  var calculatedBalancedCKG = w.getCalculatedPrecashBalanceOnLoad(ivoryCashData);
                  var balancedCKG = w.getCellFormattedValue(prepareData.BalancedCKG);
                  var absBalancedCKG = Math.abs(balancedCKG);
                  if((dateDiff-2 <= 1) && (calculatedBalancedCKG <=0) && (getCashBalance > absBalancedCKG)){
                    prepareData.AutomatedComments = 'Transfer cash now';
                  } else if(cashBalance <= 0) {
                    prepareData.AutomatedComments =  'Call capital now';
                  } else {
                    prepareData.AutomatedComments =  '';
                  }

                  console.log("Final data", prepareData);
                  //w.existingCashmanagementData.push(prepareData);
                  
                  //await w.insertSQLData(prepareData, x["FundId"]);

                  //await w.insertSQLData(prepareData, x["FundId"]);
                
          });
          });
          w.spinner = false;
          this.$modal.show("dialog", {
            title: "Success!",
            text: "Updates sucessfully applied",
          });
        }
      } catch (err) {
        this.filereader = Date.now();
        this.$modal.show("dialog", {
          title: "Error!",
          text: err,
          class: "failure",
        });
        this.spinner2 = false;
      }
    },
    async saveChanges() {
      try {
        let w = this;
        if (w.series && w.series.length>0) {
          w.spinner = true;
          let submit = {}
          let series = w.series.filter(x => x['Transaction Type'] && ( x['Transaction Type'].toLowerCase().includes('cash disb') || x['Transaction Type'].toLowerCase().includes('cash rec')))
          //console.log(series);
          series.map( x => {
          //let coinvest = x['Co-investment']
          let coinvest = x.Deal.toLowerCase().includes('co-invest')
          let tranche2 = x.Deal.toLowerCase().includes('tranche ii') 
          let deal = (coinvest || tranche2) ? x.Deal.replace(/ \(.*?\)/,'') : x.Deal
          let date = w.$moment.utc(x.Date).format('YYYY-MM-DD')
          let id = `${x['Legal Entity']}:${deal}:${date}`
          let cosplit = null, trancheii = null, balsplit = null;
          if ( coinvest ) cosplit =  x['Transaction Type'] == 'Cash Disbursed' ? -1 * x['Amount (LE)'] : x['Amount (LE)']
          if ( trancheii ) tranche2 =  x['Transaction Type'] == 'Cash Disbursed' ? -1 * x['Amount (LE)'] : x['Amount (LE)']
          if (!coinvest && !tranche2 ) balsplit = x['Transaction Type'] == 'Cash Disbursed'  ? -1 * x['Amount (LE)'] : x['Amount (LE)']
          if ( !submit[id] ) {
          submit[id] = { FundId: x['Legal Entity'], Deal: deal , WireDate: date, BalSplit: balsplit, CoSplit: cosplit, TrIISplit: trancheii, FRBBalCkg: cosplit + trancheii + balsplit }
          } else {
          submit[id].BalSplit = submit[id].BalSplit + balsplit;
          submit[id].CoSplit = submit[id].CoSplit + cosplit;
          submit[id].TrIISplit = submit[id].TrIISplit + trancheii;
          submit[id].FRBBalCkg = submit[id].FRBBalCkg + cosplit + trancheii + balsplit;
          }
          })
          let query = w.mutations.INSERT_CASHMANAGEMENT
          let submitArr = Object.keys(submit).map( x => submit[x])
                    let variableData = {
                        CashManagement_Transactions_insert_input: submitArr
                    }
                console.log('var', variableData)
         let mutate =   await this.$apollo.mutate({ mutation: query, variables: variableData })
         console.log(mutate);
          w.spinner = false;
          this.$modal.show("dialog", {
            title: "Success!",
            text: "Updates sucessfully applied",
          });
        w.series = []
        w.rowData = []
        this.filereader = Date.now();
        }
      } catch (err) {
        this.filereader = Date.now();
        this.$modal.show("dialog", {
          title: "Error!",
          text: err,
          class: "failure",
        });
        this.spinner = false;
      }
    },

    getDateData(value) {
      var w = this;
      //let date = new Date(Date.UTC(0, 0, parseInt(value), -17));
      let date = new Date(value);
      if (date.getFullYear() == '1969') {
        return '';
      } else {
        return w.handledateFormatter(w.$moment.utc(date.toISOString()).format('L'))

      }
    },
    // w.handledateFormatter(w.$moment.utc(data.value).format('L'))

    handledateFormatter(value) {
      var date = new Date(value);
      const formattedData =
        (date.getMonth() > 8
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
        "/" +
        date.getFullYear();
      return formattedData;
    },

    getCellFormattedValue(value) {
      if (
        value === undefined ||
        value == "" ||
        value === null ||
        value == "(NaN)"
      ) {
        return 0;
      } else {
        var regExp = /\(([^)]+)\)/;
        value = value.toString().replace(/,/g, "");
        var match = regExp.exec(value);
        var data = match === null ? value : "-" + match[1];
        var result = parseFloat(parseFloat(data).toFixed(2));
        return result;
      }
    },
    handleNegetiveValue(value) {
      if (!value) return
      value = value.toString().replace(")", "").replace("(", "-");
      value = value.toString().replace(/,/g, "")
      value = (parseFloat(value) + 0.000000000001).toFixed(2);
      var result = parseFloat(value) >= 0 ? value : "(" + -1 * (value) + ")";
      return result.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getCalculatedPrecashBalanceOnLoad(data){
      let w = this;
      var rowIndex = data.length-1;
      let calculateBalance = 0;
      if(rowIndex > 0){
          for(var i = rowIndex; i>=0 ; i--){
              calculateBalance = calculateBalance + w.getCellFormattedValue(data[i].BalancedCKG);
          }
      }
      return calculateBalance;
    },

    async insertSQLData(data, fundID) {
      let w = this;
      w.spinner = true;
      try {
        let obj = {};
        if (this.auditLog && this.auditLog.length > 0) {
          this.auditLog.map((x) => {
            obj[x.key] = x;
          });
        }
        data = JSON.parse(JSON.stringify(data));
        let json = JSON.stringify(data);
        let query = null;
        let variableData = {};

        const mutations = {
          INSERT_AACPVIS: gql`
          mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
            insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                affected_rows
                returning{
                    Id
                }   
            }
        }
          `,
          INSERT_AAFLIIIS: gql`
          mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
            insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                affected_rows
                returning{
                    Id
                }   
            }
        }
          `,
          INSERT_IVORYIVS: gql`
          mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
            insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                affected_rows
                returning{
                    Id
                }   
            }
        }
          `,
          INSERT_MDIVS: gql`
          mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
            insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                affected_rows
                returning{
                    Id
                }   
            }
        }
          `,
        };

        delete data.Id;
        if (fundID == "222") {
          query = mutations.INSERT_IVORYIVS;
          variableData = {
            CashManagement_cashManagement_insert_input: data,
          };
        } else if (fundID == "174") {
          query = mutations.INSERT_MDIVS;
          variableData = {
            CashManagement_cashManagement_insert_input: data,
          };
        } else if (fundID == "218") {
          query = mutations.INSERT_AAFLIIIS;
          variableData = {
            CashManagement_cashManagement_insert_input: data,
          };
        } else if (fundID == "102") {
          query = mutations.INSERT_AACPVIS;
          variableData = {
            CashManagement_cashManagement_insert_input: data,
          };
        } 
        await this.$apollo
          .mutate({
            mutation: query,
            variables: variableData,
          })
          .then((res) => {
            //w.spinner = false;
            if (res) {
              if (
                res &&
                res.data &&
                Object.keys(res.data) &&
                res.data[Object.keys(res.data)[0]]
              ) {
                console.log("Success....");
              } else {
                this.$modal.show("dialog", {
                  title: "Error!",
                  text: "Updates not applied<br/>",
                  class: "failure",
                });
              }
            }
          })
          .catch((err) => {
            w.spinner = false;
            this.$modal.show("dialog", {
              title: "Error!",
              text: err,
              class: "failure",
            });
          });
      } catch (err) {
        w.spinner = false;
        this.$modal.show("dialog", {
          title: "Error!",
          text: err,
          class: "failure",
        });
      }
    },
  },
};
